import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { fetchCustomizationData } from "../../../../Redux/actions/appCustomizationAction";
import {
  setData,
  setEnabledSections,
  setShowModal,
} from "../../../../Redux/reducers/appCustomizationSlice";
import MenuScreenPreview from "./Previews/MenuScreenPreview";
import SelectCustomUrl from "./Modals/SelectCustomUrl";

const menuItems = [
  "Discover Recipes",
  "Appointments",
  "Medications",
  "Account settings",
];

const MenuScreen = () => {
  const { id: studyId } = useParams();
  const dispatch = useAppDispatch();
  const selectedCategory = useAppSelector(
    (state) => state.appCustomization.category
  );
  const loading = useAppSelector((state) => state.appCustomization.loading);
  const menuScreenData = useAppSelector((state) => state.appCustomization.data);
  const enabledSections = useAppSelector(
    (state) => state.appCustomization.enabledSections
  );
  const showModal = useAppSelector(
    (state) => state.appCustomization.showAddUrlModal
  );
  const [key, setKey] = useState<string>("");

  useEffect(() => {
    dispatch(fetchCustomizationData(studyId, selectedCategory));
    return () => {
      dispatch(setData([]));
      dispatch(setEnabledSections([]));
    };
  }, [dispatch, selectedCategory, studyId]);

  const handleFieldChange = (key: string, fieldName: string, value: any) => {
    const updatedData = menuScreenData.map((item: any) =>
      item.key === key ? { ...item, [fieldName]: value } : item
    );
    const enabled = updatedData.filter((item: any) => item.enabled);
    dispatch(setData(updatedData));
    dispatch(setEnabledSections(enabled));
  };

  return (
    <Stack
      direction="row"
      justifyContent={"space-between"}
      sx={{ height: "100%" }}
    >
      {loading && (
        <Backdrop
          open={loading}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <CircularProgress sx={{ color: "#fff" }} />
        </Backdrop>
      )}
      <Stack
        sx={{
          flex: 1,
          minHeight: "1px",
          height: "100%",
          overflow: "auto",
          py: 2.5,
          px: 2,
          alignItems: "center",
          width: "100%",
        }}
        gap={2}
      >
        {menuScreenData.map((item: any) => (
          <Box
            key={item.key}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                width: "100%",
              }}
            >
              <Stack>
                <Checkbox
                  checked={item.enabled || false}
                  onChange={() =>
                    handleFieldChange(item.key, "enabled", !item.enabled)
                  }
                  disabled={item.enabled && enabledSections.length < 3}
                />
              </Stack>

              <Stack sx={{ width: "100%" }}>
                <Typography>Text</Typography>
                <TextField
                  value={item.text}
                  onChange={(e) =>
                    handleFieldChange(item.key, "text", e.target.value)
                  }
                  variant="outlined"
                  placeholder="Enter text"
                />
              </Stack>
              <Stack sx={{ width: "100%" }}>
                <Typography>Connector</Typography>
                <Select
                  value={item.connector || ""}
                  onChange={(e) => {
                    if (e.target.value !== "url") {
                      handleFieldChange(item.key, "connector", e.target.value);
                    } else {
                      setKey(item.key);
                      dispatch(setShowModal(true));
                    }
                  }}
                >
                  {menuItems.map((item: string) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                  <MenuItem value="url">URL</MenuItem>
                  {!menuItems.includes(item.connector) && item.connector && (
                    <MenuItem key={item.connector} value={item.connector}>
                      {item.connector}
                    </MenuItem>
                  )}
                </Select>
              </Stack>
            </Box>
          </Box>
        ))}
      </Stack>
      <Box sx={{ ml: "auto", height: "100%" }}>
        <MenuScreenPreview />
      </Box>
      {showModal && (
        <SelectCustomUrl index={key} handleFieldChange={handleFieldChange} />
      )}
    </Stack>
  );
};

export default memo(MenuScreen);
